module.exports = __webpack_public_path__ + "static/media/about-2.3677d4db.jpg";